import { PHONE_REGEX } from "../constants/global";

export async function checkPhoneNumber(_, value) {
  if (value && !value.match(PHONE_REGEX)) {
    throw new Error("Номер телефона имеет неверный формат");
  }
}
